import suggestedSuds from '../data/suggestedSuds.json';

export async function fetchSudsData(): Promise<any> {
  const SUDS_LIST = 'suds_locations';
  const apiUrl = `https://${process.env.NEXT_PUBLIC_API_ID}.execute-api.${process.env.NEXT_PUBLIC_REGION}.amazonaws.com/dev/${SUDS_LIST}`;

  try {
    const response = await fetch(apiUrl, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`Error fetching SUDS data: ${response.status} ${response.statusText}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Failed to fetch SUDS data:', error);
    throw error;
  }
}

export async function fetchSuggestedSudsData(): Promise<any> {
  return suggestedSuds;
}
